export default "__VITE_ASSET__F_mMYo6R__"